const ChatInputBlock = ({ children }) => {
    return (
        <div className="chat-input d-flex align-items-center justify-content-center w-100">
            {children}
        </div>
    );
}

export default ChatInputBlock;
